

export const TitleAccent = ({ className, children }) => {
  return <div style={{
    paddingRight: '2rem',
    paddingLeft: '.5rem',
    clipPath: 'polygon(0 1%, 100% 0, 90% 100%, 0% 100%)',
    background: 'var(--red)',
    width: 'max-content',
    color: 'white'
  }} className={className}>
    {children}
  </div>
}